import React, { Component } from 'react';
import MenuConf from './MenuConf';
import { FormattedMessage } from 'react-intl';
import { demoUrl } from '../../app/AppHelpers';
class Menu extends Component {
    constructor(props) {
        super();
        this.handleClick = this.handleClick.bind(this);
    }
    handleClick(scrollTo) {
        const element = document.getElementById(scrollTo);
        element.scrollIntoView({ behavior: "smooth" });
    }

    render() {
        return (
            MenuConf.menuItems.map((menuItem, i) => {
                let isDemo = (menuItem.id === 'demo' ? demoUrl : false);
                return (
                    <li key={i}>
                        <a href={(!isDemo ? undefined : isDemo)} onClick={!isDemo ? () => this.handleClick(menuItem.pointer) : undefined} /*target="_blank"*/ key={menuItem.id} aria-label={'Scroll to ' + menuItem.id}>
                            <FormattedMessage id={"MenuItem.label." + menuItem.id} defaultMessage=" " />
                        </a>
                    </li>
                );
            })

        );
    }
}

export default Menu;


// WEBPACK FOOTER //
// ./src/containers/menu/Menu.js